import gsap from 'gsap'

// Loading
const createLoading = () => {
  const loadingElement = document.createElement('div')
  loadingElement.id = 'loading'

  const loaderElement = document.createElement('div')
  loaderElement.classList.add('loader')

  loadingElement.appendChild(loaderElement)
  document.body.appendChild(loadingElement)
}

const removeLoading = () => {
  const loadingElement = document.getElementById('loading')
  if (loadingElement) {
    loadingElement.style.opacity = '0'
  }
  setTimeout(() => {
    if (loadingElement) {
      loadingElement.style.display = 'none'
    }
  }, 250)
}

createLoading()

window.addEventListener('DOMContentLoaded', () => {
  removeLoading()
})

// nav 阴影
const navDom = document.querySelector('#nav')
window.addEventListener('scroll', () => {
  requestIdleCallback(() => {
    if (document.documentElement.scrollTop === 0) {
      navDom.style.boxShadow = '0 0 0 '
    } else {
      navDom.style.boxShadow = 'rgba(0, 0, 0, 0.04) 0 3px 5px'
    }
  })
})

// nav 菜单
const navMenuDom = document.querySelector('#nav > div.container.small > div.menu')
const navMenuItemsDom = document.querySelector('#nav > div.container.small > div.menu > ul')

const navMenuInputDom = document.querySelector('#burger')

let isMenuOpen = false

const showMenu = () => {
  gsap.to(navMenuItemsDom, {
    height: 'auto',
    duration: 0.2,
    ease: 'power2.in',
  })
  isMenuOpen = true
  navMenuInputDom.checked = false
}

const hideMenu = () => {
  gsap.to(navMenuItemsDom, {
    height: 0,
    duration: 0.2,
    ease: 'power2.in',
  })
  isMenuOpen = false
  navMenuInputDom.checked = true
}

const initMenuStatus = () => {
  gsap.set(navMenuItemsDom, {
    height: 0,
  })
  navMenuInputDom.checked = false
}

window.addEventListener('load', () => {
  initMenuStatus()
})

navMenuDom.addEventListener('click', (e) => {
  e.stopPropagation()

  if (!isMenuOpen) {
    showMenu()
  } else {
    hideMenu()
  }
})

window.addEventListener('click', () => {
  if (isMenuOpen) {
    hideMenu()
  }
})

const navMenuLinkDomList = document.querySelectorAll(
  '#nav > div.container.small > div.menu > ul > li > a',
)

navMenuLinkDomList.forEach((item) => {
  item.addEventListener('click', (e) => {
    e.stopPropagation()
  })
})

navMenuInputDom.addEventListener('click', (e) => {
  e.stopPropagation()
  e.stopImmediatePropagation()
})

// footer
const wechatDom = document.querySelector('#footer > div > ul:nth-child(2) > li.wechat > span')
const wechatImgDom = document.querySelector('#footer > div > ul:nth-child(2) > li.wechat > img')

wechatDom.addEventListener('mouseenter', () => {
  gsap.to(wechatImgDom, {
    opacity: 1,
    duration: 0.3,
    display: 'block',
  })
})

wechatDom.addEventListener('mouseleave', () => {
  gsap.to(wechatImgDom, {
    opacity: 0,
    duration: 0.3,
    display: 'none',
  })
})

// 图片懒加载
// const lazyLoadImages = () => {
//   const images = document.querySelectorAll(`img`)
//   console.log(images)
//   const loadImage = (img) => {
//     const src = img.getAttribute('data-src')
//     if (src) {
//       img.style.display = 'block !important'
//     }
//   }
//
//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach((entry) => {
//       if (entry.isIntersecting) {
//         loadImage(entry.target)
//         observer.unobserve(entry.target)
//       }
//     })
//   })
//
//   images.forEach((img) => {
//     observer.observe(img)
//   })
// }
//
// window.addEventListener('DOMContentLoaded', () => {
//   lazyLoadImages()
// })
